export var REQUEST_TIMEOUT = 20000;
export var DOCUMENT_TITLE = 'The Home Depot';
export var getCheckoutAccessTypeLabel = function (enabledHdPass) {
    return enabledHdPass ? 'HD Pass' : 'Virtual ID';
};
